import { createElement, EventHandler, removeClass, addClass, Droppable } from '@syncfusion/ej2-base';
import * as cls from '../../common/base/css-constant';
/**
 * Module to render Axis Field Table
 */
/** @hidden */
export class AxisTableRenderer {
    /** Constructor for render module */
    constructor(parent) {
        this.droppableInstances = [];
        this.parent = parent;
    }
    /**
     * Initialize the axis table rendering
     *
     * @returns {void}
     * @private
     */
    render() {
        if (!this.parent.isAdaptive) {
            const axisTable = createElement('div', {
                className: cls.AXIS_TABLE_CLASS + ' ' + (this.parent.dataType === 'olap' ? cls.OLAP_AXIS_TABLE_CLASS : '')
            });
            this.leftAxisPanel = createElement('div', { className: cls.LEFT_AXIS_PANEL_CLASS });
            this.rightAxisPanel = createElement('div', { className: cls.RIGHT_AXIS_PANEL_CLASS });
            this.parent.dialogRenderer.parentElement.appendChild(axisTable);
            axisTable.appendChild(this.leftAxisPanel);
            axisTable.appendChild(this.rightAxisPanel);
            this.axisTable = axisTable;
            this.renderAxisTable();
        }
        this.parent.axisFieldModule.render();
    }
    renderAxisTable() {
        const fieldLabels = ['filters', 'rows', 'columns', 'values'];
        for (let len = 0, lnt = fieldLabels.length; len < lnt; len++) {
            const axis = createElement('div', {
                className: cls.FIELD_LIST_CLASS + '-' + fieldLabels[len]
            });
            const axisTitleWrapper = createElement('div', {
                className: cls.AXIS_ICON_CLASS + '-container'
            });
            const axisTitle = createElement('div', {
                className: cls.AXIS_HEADER_CLASS,
                attrs: { title: this.parent.localeObj.getConstant(fieldLabels[len]) }
            });
            axisTitle.innerText = this.parent.localeObj.getConstant(fieldLabels[len]);
            axisTitleWrapper.appendChild(this.getIconupdate(fieldLabels[len]));
            axisTitleWrapper.appendChild(axisTitle);
            const axisContent = createElement('div', { className: cls.AXIS_CONTENT_CLASS + ' ' + 'e-' + fieldLabels[len] });
            let localePrompt;
            if (fieldLabels[len] === 'rows') {
                localePrompt = this.parent.localeObj.getConstant('dropRowPrompt');
            }
            else if (fieldLabels[len] === 'columns') {
                localePrompt = this.parent.localeObj.getConstant('dropColPrompt');
            }
            else if (fieldLabels[len] === 'values') {
                localePrompt = this.parent.localeObj.getConstant('dropValPrompt');
            }
            else {
                localePrompt = this.parent.localeObj.getConstant('dropFilterPrompt');
            }
            const axisPrompt = createElement('span', {
                className: cls.AXIS_PROMPT_CLASS
            });
            axisPrompt.innerText = localePrompt;
            const droppable = new Droppable(axisContent, {});
            this.droppableInstances.push(droppable);
            axis.appendChild(axisTitleWrapper);
            axis.appendChild(axisContent);
            axis.appendChild(axisPrompt);
            if (len <= 1) {
                this.leftAxisPanel.appendChild(axis);
            }
            else {
                this.rightAxisPanel.appendChild(axis);
            }
            this.unWireEvent(axisContent);
            this.wireEvent(axisContent);
        }
    }
    getIconupdate(axis) {
        const axisWrapper = createElement('span', {
            attrs: { 'tabindex': '-1', 'aria-disabled': 'false' },
            className: cls.AXIS_ICON_CLASS + '-icon-container'
        });
        const axisElement = createElement('span', {
            attrs: {
                'tabindex': '-1', 'aria-disabled': 'false'
            },
            className: cls.ICON + ' ' + cls.AXIS_ICON_CLASS + '-' + axis
        });
        axisWrapper.appendChild(axisElement);
        return axisWrapper;
    }
    wireEvent(element) {
        EventHandler.add(element, 'mouseover', this.updateDropIndicator, this);
        EventHandler.add(element, 'mouseleave', this.updateDropIndicator, this);
    }
    unWireEvent(element) {
        EventHandler.remove(element, 'mouseover', this.updateDropIndicator);
        EventHandler.remove(element, 'mouseleave', this.updateDropIndicator);
    }
    updateDropIndicator(e) {
        const parentElement = this.parent.dialogRenderer.parentElement;
        if (this.parent.isDragging && e.target.classList.contains(cls.AXIS_CONTENT_CLASS) && e.type === 'mouseover') {
            removeClass([].slice.call(parentElement.querySelectorAll('.' + cls.DROP_INDICATOR_CLASS)), cls.INDICATOR_HOVER_CLASS);
            removeClass([].slice.call(parentElement.querySelectorAll('.' + cls.DROP_INDICATOR_CLASS + '-last')), cls.INDICATOR_HOVER_CLASS);
            const element = [].slice.call(e.target.querySelectorAll('.' + cls.PIVOT_BUTTON_WRAPPER_CLASS));
            if (element.length > 0) {
                addClass([element[element.length - 1].querySelector('.' + cls.DROP_INDICATOR_CLASS + '-last')], cls.INDICATOR_HOVER_CLASS);
            }
        }
        else if (!this.parent.isDragging || (!e.target.classList.contains(cls.DROPPABLE_CLASS) && e.type === 'mouseleave')) {
            removeClass([].slice.call(parentElement.querySelectorAll('.' + cls.DROP_INDICATOR_CLASS)), cls.INDICATOR_HOVER_CLASS);
            removeClass([].slice.call(parentElement.querySelectorAll('.' + cls.DROP_INDICATOR_CLASS + '-last')), cls.INDICATOR_HOVER_CLASS);
        }
    }
    /**
     * Destroys the AxisTableRenderer instance
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        if (this.axisTable) {
            const axisContentElements = this.axisTable.querySelectorAll('.' + cls.AXIS_CONTENT_CLASS);
            for (let i = 0; i < axisContentElements.length; i++) {
                this.unWireEvent(axisContentElements[i]);
            }
        }
        for (let i = 0; i < this.droppableInstances.length; i++) {
            if (this.droppableInstances[i] && !this.droppableInstances[i].isDestroyed) {
                this.droppableInstances[i].destroy();
            }
        }
        this.droppableInstances = [];
        if (this.axisTable && this.axisTable.parentNode) {
            this.axisTable.parentNode.removeChild(this.axisTable);
        }
        this.axisTable = null;
        this.leftAxisPanel = null;
        this.rightAxisPanel = null;
    }
}
